export const DEFAULT_MAX_SIZE = 20_971_520; // 20MB
